import { POPUP_ADDRESS } from "../constants/ActionTypes";
/**
 *
 * @POPUP_STATE: 0:off 1: on
 * @POPUP_MODULE: module_name
 * @POPUP_PARAMETERS: parameters
 * @POPUP_CALLBACK_KEY: callback(key)
 * @POPUP_CALLBACK_VALUE: callback(value)
 */
const initialPopupState = {
  POPUP_STATE: 0,
  POPUP_MODULE: null,
  POPUP_PARAMETERS: null,
  POPUP_CALLBACK_KEY: null,
  POPUP_CALLBACK_VALUE: null
};

export default function (state = initialPopupState, action = {}){
  let POPUP_STATE = action.POPUP_STATE,
      POPUP_MODULE = action.POPUP_MODULE,
      POPUP_PARAMETERS = action.POPUP_PARAMETERS,
      POPUP_CALLBACK_KEY = action.POPUP_CALLBACK_KEY,
      POPUP_CALLBACK_VALUE = action.POPUP_CALLBACK_VALUE;
  switch( action.type ){
    case POPUP_ADDRESS.POPUP_STATE:
      return Object.assign({}, state, {
        POPUP_STATE,
        POPUP_MODULE,
        POPUP_PARAMETERS,
        POPUP_CALLBACK_KEY,
        POPUP_CALLBACK_VALUE
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./common/reducers/popup_address.js